module.exports = __webpack_public_path__ + "img/Fregier.2a4fc837.png";